Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-product-compare-list'),
        wrapper;

    if ($wrapper.length < 1)
        return;

    wrapper = $wrapper.get(0);

    var model = null;

    wrapper.loading = function loading (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        }
    };

    wrapper.extendModel = function () {
        if (window.B2BModel === undefined) return;
        _.extend(model, window.B2BModel);
    };

    wrapper.update = function () {
        wrapper.loading(true);

        var html = Vendd.Handlebars.parse(Handlebars.partials.productCompareList, model);

        wrapper.bind(html);

        wrapper.loading(false);
    };

    wrapper.bind = function bind(html) {
        $wrapper.html(html);
        Vendd.MessageBus.publish($wrapper, new Vendd.Widget.Messages.BindControl($wrapper));

    };

    Vendd.MessageBus.subscribe(Vendd.ProductCompare.Messages.Changed, wrapper, function (envelope) {
        wrapper.loading(true);
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.ProductCompare.Messages.GetModel());
    });

    Vendd.MessageBus.subscribe(Vendd.ProductCompare.Messages.GetModelSuccess, wrapper, function (envelope) {
        model = envelope.message.data.model;

        wrapper.loading(true);
        wrapper.extendModel();
        wrapper.update();
    });

    Vendd.MessageBus.publishAsync(wrapper, new Vendd.ProductCompare.Messages.GetModel());
});